import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eMucThuTamThuActionIds } from "./../../action-types/muc-thu/IMucThuTamThuActionTypes";

import { mucThuTamThuSinhVienApi } from "../../../api/chung-tu/mucThuTamThuSinhVienApi";
import { IMucThuTamThuSinhVienSelectRequest } from "../../../model/request/chung-tu-tam-thu/IMucThuTamThuSinhVienSelectRequest";
import { IMucThuTamThuActionTypes } from "../../action-types/muc-thu/IMucThuTamThuActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* mucThuTamThuSaga(): any {
  yield takeLatest(
    eMucThuTamThuActionIds.LOAD_MUC_THU_LOAD_START,
    loadMucThuWorker
  );
  yield takeLatest(
    eMucThuTamThuActionIds.LOAD_SO_TIEN_CON_LAI_LOAD_START,
    loadSoTienConLaiWorker
  );
}

function* loadMucThuWorker(action: IMucThuTamThuActionTypes): any {
  const id_sv = action.payload as string;
  const res: IBaseRespone = yield call(
    mucThuTamThuSinhVienApi.SelectBySinhVien,
    { id_sv: id_sv } as IMucThuTamThuSinhVienSelectRequest
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_MUC_THU_LOAD_SUCCESS({
        id_sv: id_sv,
        data: res.data,
      })
    );
  } else {
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_MUC_THU_LOAD_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* loadSoTienConLaiWorker(action: IMucThuTamThuActionTypes): any {
  const id_sv = action.payload as string;
  const res: IBaseRespone = yield call(
    mucThuTamThuSinhVienApi.GetSoTienConLaiBySinhVien,
    { id_sv: id_sv } as IMucThuTamThuSinhVienSelectRequest
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_SO_TIEN_CON_LAI_LOAD_SUCCESS({
        id_sv: id_sv,
        data: res.data,
      })
    );
  } else {
    yield put(
      rootActions.mucThu.mucthuTamThu.LOAD_SO_TIEN_CON_LAI_LOAD_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
